export const Loading = () => {
  return (
    <div className="loading-layout absolute inset-1/2 w-[40px] h-[40px] z-50">
      <img src="./img/loading-layout.svg" alt="loading" />
    </div>
  );
};
